/*
 * Sorrem is a set of single-page apps, one per top-level path ("page"):
 * /login, /intro, /character, /crucibles, /join, /lore, /debug and
 * /editors. Navigation inside a page stays in the router; moving to another
 * page loads it fresh, so each page starts clean (no stale cached data, no
 * game worker or scene left over from a run).
 */

export interface AppNavigateOptions {
    replace?: boolean;
}

export type AppNavigateFunction = (to: string, options?: AppNavigateOptions) => void;

/** The page a path belongs to: its first segment ('character' for '/character/overview'). */
export function resolvePageRoot(path: string): string {
    const pathname = path.split(/[?#]/)[0] ?? '';
    return pathname.split('/').filter((segment) => segment.length > 0)[0] ?? '';
}

/** Whether moving from `fromPath` to `toPath` leaves the current page. */
export function isCrossingPageRoot(fromPath: string, toPath: string): boolean {
    return resolvePageRoot(fromPath) !== resolvePageRoot(toPath);
}

/** Loads another page fresh (a full page load). */
export function navigateToPage(path: string, options: AppNavigateOptions = {}): void {
    if (options.replace) {
        window.location.replace(path);
        return;
    }

    window.location.assign(path);
}
